import accountDao from '../../../../dao/smbpartner/accountDao';
import {loadAuth} from '../../../../components/auth/reducers';

const SET_PWD_FIELD = 'pages/partner/settings/updateaccount/SET_PWD_FIELD';
const UPDATE_ACCOUNT = 'pages/partner/settings/updateaccount/UPDATE_ACCOUNT';
const UPDATE_ACCOUNT_SUCCESS =
  'pages/partner/settings/updateaccount/UPDATE_ACCOUNT_SUCCESS';

const initialState = {
  showPwdField: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_PWD_FIELD:
      return {
        ...state,
        showPwdField: !state.showPwdField,
      };
    case UPDATE_ACCOUNT:
      return {
        ...state,
      };
    case UPDATE_ACCOUNT_SUCCESS:
      return {
        ...state,
      };
    default:
      return {
        ...state,
      };
  }
};

export function setPwdField() {
  return {
    type: SET_PWD_FIELD,
  };
}

export function updateAccount(account) {
  return dispatch => {
    dispatch({type: UPDATE_ACCOUNT});
    return accountDao.updateAccount(account).then(json => {
      dispatch({type: UPDATE_ACCOUNT_SUCCESS});
      dispatch(loadAuth());
      return json;
    });
  };
}
